// Todo: YG-3885: Use the real experiment hook when required, or delete this flag once the experiment is over
export const selectIsBlackBtn = () => false;
